// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-users-container {
  padding: 20px;
}

/* Role badge styles */
.MuiChip-root.super-admin {
  background-color: #f44336;
  color: white;
}

.MuiChip-root.admin {
  background-color: #ff9800;
  color: white;
}

.MuiChip-root.viewer {
  background-color: #2196f3;
  color: white;
}

/* Table styles */
.MuiTableRow-root:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

/* Action buttons */
.MuiIconButton-root {
  transition: all 0.2s ease-in-out;
}

.MuiIconButton-root:hover {
  transform: scale(1.1);
}

/* Responsive design */
@media (max-width: 768px) {
  .admin-users-container {
    padding: 10px;
  }
  
  .MuiTableContainer-root {
    overflow-x: auto;
  }
  
  .MuiTableCell-root {
    padding: 8px 4px;
    font-size: 0.875rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/AdminUsers.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,qCAAqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF","sourcesContent":[".admin-users-container {\n  padding: 20px;\n}\n\n/* Role badge styles */\n.MuiChip-root.super-admin {\n  background-color: #f44336;\n  color: white;\n}\n\n.MuiChip-root.admin {\n  background-color: #ff9800;\n  color: white;\n}\n\n.MuiChip-root.viewer {\n  background-color: #2196f3;\n  color: white;\n}\n\n/* Table styles */\n.MuiTableRow-root:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n/* Action buttons */\n.MuiIconButton-root {\n  transition: all 0.2s ease-in-out;\n}\n\n.MuiIconButton-root:hover {\n  transform: scale(1.1);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .admin-users-container {\n    padding: 10px;\n  }\n  \n  .MuiTableContainer-root {\n    overflow-x: auto;\n  }\n  \n  .MuiTableCell-root {\n    padding: 8px 4px;\n    font-size: 0.875rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
